import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/excavation-services/components/ExcavationInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
